import type { Theme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

/**
 * Whether the screen is too narrow for the desktop layout — the tab bar, and the wide data tables
 * that read one route or run per row. Below MUI's `md` (900px) a phone or a portrait tablet gets
 * the drawer and the card lists instead. Read synchronously, so a phone never flashes the desktop
 * shell on its first paint.
 */
export const useCompactLayout = () =>
  useMediaQuery((theme: Theme) => theme.breakpoints.down('md'), { noSsr: true });

export default useCompactLayout;
